import {getSafely} from 'shared/web';

import {WORKSHOP_WIDGET_GROUPS, WorkshopLeafKey} from './workshopWidgetGroups';

type WorkshopLeafValues = Record<WorkshopLeafKey, boolean>;

const ALL_WORKSHOP_WIDGETS: readonly WorkshopLeafKey[] = WORKSHOP_WIDGET_GROUPS.flatMap((group) =>
  group.widgets.map((widget) => widget.key)
);

/**
 * Workshop widget fields to send in the dashboard-settings payload. Returns an
 * empty object when the workshop module is disabled so the settings of a module
 * the user cannot see are never written to the backend.
 */
export const getWorkshopSettingsPayload = (
  values: WorkshopLeafValues,
  isWorkshopModuleEnabled: boolean
): Partial<WorkshopLeafValues> => {
  if (!isWorkshopModuleEnabled) {
    return {};
  }

  return ALL_WORKSHOP_WIDGETS.reduce<Partial<WorkshopLeafValues>>(
    (payload, leaf) => ({...payload, [leaf]: getSafely(values, leaf, false)}),
    {}
  );
};
